import utils = egr.wcf.utils;

export function formatSizeUnits(bytes: number, fractionDigits: number = 2): string {
    if  (bytes === 0) {
        return '0 Bytes';
    }
    const base: number = 1024;
    const texts: ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const f: number = Math.floor(Math.log(bytes) / Math.log(base));
    return `${parseFloat((bytes / Math.pow(base, f)).toFixed(fractionDigits))} ${texts[f]}`;
}

export function getCurrencyString(
    value: number | undefined,
    currency: string,
    language: string = 'de',
    currencyDisplay: 'symbol' | 'name' | 'code' = 'symbol',
    hideCurrency: boolean = false
): string {
    if (value == null) {
        return '';
    }
    if (Intl === undefined) {
        return value + ' ' + currency;
    }

    if (hideCurrency) {
        return new Intl.NumberFormat(language, { style: 'currency', currency, currencyDisplay: 'code' }).format(value).replace(currency, '').trim();
    }

    return new Intl.NumberFormat(language, { style: 'currency', currency, currencyDisplay}).format(value);
}

// https://stackoverflow.com/questions/7616461/generate-a-hash-from-string-in-javascript-jquery
export function getHash(originalString: string): number {
    let hash: number = 0;
    if (originalString.length === 0) {
        return hash;
    }
    for (let i: number = 0; i < originalString.length; i++) {
        const chr: number = originalString.charCodeAt(i);
        // tslint:disable-next-line:no-bitwise
        hash = ((hash << 5) - hash) + chr;
        // tslint:disable-next-line:no-bitwise
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export function multilineTextToArray(
    input: string | undefined,
    keepEmptyLines?: boolean,
    trimLines?: boolean,
    removeTrailingEmptyLines?: boolean
): Array<string> {
    if (utils.string.isNullOrEmpty(input)) {
        return [];
    }

    const temp: string = input.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    const lines: Array<string> = temp.split('\n').filter((value: string) => {
        if (keepEmptyLines) {
            return true;
        }
        return (value != null && value !== '');
    });

    if (trimLines) {
        return lines.map(trim);
    }

    if (removeTrailingEmptyLines) {
        for (let i: number = lines.length - 1; i >= 0; i--) {
            lines.length = i + 1;
            if (utils.string.isNotNullOrEmpty(lines[i])) {
                break;
            }
        }
    }

    return lines;
}

export function trim(value: string): string {
    return value.trim();
}

export function getValidString(value: string | undefined, fallback: string | undefined): string {
    if (utils.string.isNotNullOrEmpty(value)) {
        return value;
    }
    if (utils.string.isNotNullOrEmpty(fallback)) {
        return fallback;
    }
    return '';
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/egr-gui-utils/StringHelper.ts